<script setup lang="ts">
import ScBtn from '@/components/common/widget/ScBtn.vue';
import { nextTick, reactive, ref, watch } from 'vue';
import { useElementSize } from '@vueuse/core';

const props = defineProps<{
  value: string;
  handler?: (value: string) => Promise<boolean>;
}>();

const data = reactive({
  edit: false,
  value: props.value,
  width: '',
});

watch(
  () => props.value,
  () => {
    data.value = props.value;
  },
  { immediate: true }
);
const content = ref<HTMLElement>();
const input = ref<HTMLInputElement>();
const { width } = useElementSize(content);

function edit() {
  data.edit = true;
  data.value = props.value;
  data.width = Math.max(width.value, 96) + 'px';
  nextTick(() => input.value?.focus());
}

function close() {
  data.edit = false;
  data.value = props.value;
}

async function submit() {
  if (props.handler) {
    if (await props.handler(data.value)) {
      data.edit = false;
    }
  }
}

function ellipsis(text: string | undefined, max: number) {
  if (!text) {
    return '';
  }
  if (text.length <= max) {
    return text;
  } else {
    return text.slice(0, max - 3) + '...';
  }
}

function showLong(text: string | undefined, max: number) {
  if (!text) {
    return '';
  }
  if (text.length > max) {
    return text;
  }
}
</script>

<template>
  <div class="flex-row" style="position: relative;">
    <div class="flex-row" :style="{visibility: data.edit ? 'hidden' : 'visible'}">
      <a-tooltip :title="showLong(value, 30)" placement="top">
        <div class="edit-text-box-content" ref="content">
          {{ ellipsis(value, 30) }}
        </div>
      </a-tooltip>
      <sc-btn
        v-if="handler"
        type="link"
        size="small"
        icon-style="color: #363636"
        icon="EditOutlined"
        :handler="edit"
      />
    </div>
    <div
      class="flex-row"
      style="position: absolute; z-index: 100;left: 0;background: #ffffff;"
      v-if="data.edit"
    >
      <input
        class="edit-text-box-input"
        ref="input"
        v-model="data.value"
        :style="{ width: data.width }"
      />
      <sc-btn type="link" size="small" icon="CheckOutlined" :handler="submit" />
      <sc-btn
        type="link"
        size="small"
        icon="CloseOutlined"
        icon-style="color: red;"
        :handler="close"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.flex-row {
  display: flex;
  flex-direction: row;
}

.edit-text-box-content {
  box-sizing: border-box;
  height: 24px;
  text-align: left;
  border-bottom: 1px solid transparent;
}

.edit-text-box-input {
  width: auto;
  box-sizing: border-box;
  height: 24px;
  outline: none;
  border: none;
  border-bottom: 1px solid;
}
</style>
